module.exports = __webpack_public_path__ + "img/book_2.cc43dc61.svg";